export type Filter = 'all' | 'high_confidence' | 'not_me' | 'is_me';

/**
 * Normalized mention section values used for tracking and API calls.
 * These values are shared across both non-filtered and filtered mention views
 * to ensure consistent analytics and data aggregation.
 */
export type NormalizedMentionSection =
  | 'all'
  | 'high_confidence'
  | 'me'
  | 'not_me'
  | 'new';

// Map legacy Filter type to API/tracking format
export const FILTER_TO_API_FORMAT: Record<Filter, NormalizedMentionSection> = {
  all: 'all',
  high_confidence: 'high_confidence',
  not_me: 'not_me',
  is_me: 'me',
};

export interface Mention {
  id: number;
  mentioning_work_id: number;
  highly_cited?: boolean;
  well_known_author?: boolean;
  is_hidden?: boolean;
  is_public?: boolean;
  vector_similarity_score?: number | null;
}

export interface Action {
  id: number;
  citation: boolean;
  action: 'is_me' | 'undo_is_me' | 'not_me' | 'undo_not_me';
}
